export default {
  USUARIO_LOGADO: function () {
    var token = localStorage.getItem('token');

    if (token) {
      var jwt = require('jsonwebtoken');
      try {
        var tokenObject = jwt.verify(token, `${process.env.TOKEN_SECRET}`);
      } catch (error) {
        localStorage.removeItem('token');
        return false;
      }
      var user = {}
      user.idUsuario = parseInt(tokenObject.id);
      user.email = tokenObject.sub;
      user.nome = tokenObject.nome;
      user.perfil = tokenObject.perfil;
      user.token = token;
      user.grupos = tokenObject.grupos;
      user.gestaoTaxasSeguro = tokenObject.gestaoTaxasSeguro === true;

      return user;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/usuario-logado.js